import { agentWidgetsApiBaseUrl } from '../../api/server';
import runtimeConfig from '../../runtimeConfig';

let integration = null;
let loading = null;
// Customer embeds keep the published npm widget.
const embedScriptUrl = () => new URL(process.env.REACT_APP_AGENT_WIDGET_SCRIPT_URL || 'https://cdn.jsdelivr.net/npm/anthropod-voice-widget@latest/dist/widget.umd.js', window.location.origin).href;
// The dashboard's Test Chat and preview load the widget build served with this app
// (anthropod-voicebot-widget codex/chat-over-livekit @ 9c77c8d, LiveKit chat), until it is
// published. The commit is in the file name because nginx caches .js files as immutable.
// REACT_APP_AGENT_WIDGET_SCRIPT_URL (runtime) overrides it.
const BUNDLED_WIDGET_SCRIPT = '/agent-widget/widget-9c77c8d.umd.js';
const dashboardScriptUrl = () => new URL(runtimeConfig.REACT_APP_AGENT_WIDGET_SCRIPT_URL || BUNDLED_WIDGET_SCRIPT, window.location.origin).href;
const escapeAttribute = value => String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

export function createAgentWidgetEmbed({ widgetId, publicApiKey }) {
  return `<script src="${escapeAttribute(embedScriptUrl())}"></script>
<anthropod-agent-widget widget-id="${escapeAttribute(widgetId)}" public-api-key="${escapeAttribute(publicApiKey)}" api-base-url="${escapeAttribute(agentWidgetsApiBaseUrl)}"></anthropod-agent-widget>`;
}

export function loadSharedWidgetUI() {
  if (integration) return Promise.resolve(integration);
  if (window.VoiceBotWidget?.mountTestChat) { integration = window.VoiceBotWidget; return Promise.resolve(integration); }
  if (loading) return loading;
  loading = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = dashboardScriptUrl(); script.async = true;
    script.onload = () => {
      if (!window.VoiceBotWidget?.mountTestChat || !window.VoiceBotWidget?.createDashboardSessionAdapter) {
        script.remove(); loading = null; reject(new Error('The chat widget is unavailable. Please reload and try again.')); return;
      }
      integration = window.VoiceBotWidget; resolve(integration);
    };
    script.onerror = () => { script.remove(); loading = null; reject(new Error('Unable to load the chat widget. Please reload and try again.')); };
    document.head.appendChild(script);
  });
  return loading;
}
